import { MatThemeColor } from '../enums/mat-theme-color';

/**
 * Model defining a one-way data interface from a component that invokes an Angular Material modal
 * to the modal itself for a confirmation.
 *
 * - `summary`: Summary for the confirmation modal - appears as title.
 * - `detail`: Additional details or instructions for the confirmation. A single paragraph, or
 *   several rendered one below the other.
 * - `iconColor`: Color of the warning icon.
 */
export type ConfirmationModalModel = {
    summary: string;
    detail: string | string[];
    /** @default MatThemeColor.WARN */
    iconColor?: MatThemeColor;
};

/**
 * Enum representing possible action options for a confirmation modal.
 * - `CONFIRM`: Indicates a user's confirmation of an action.
 * - `REJECT`: Indicates a user's rejection or cancellation of an action.
 */
export enum ConfirmationModalAction {
    CONFIRM = 'CONFIRM',
    REJECT = 'REJECT',
}
